import {Record} from 'immutable';

export const EntityTypes = {
    Invoice: 'Famly.Daycare:Invoice',
    BillPayer: 'Famly.Daycare:BillPayer',
    Employee: 'Famly.Daycare:Employee',
    Relation: 'Famly.Daycare:Relation',
    Child: 'Famly.Daycare:Child',
    Message: 'Famly.Conversation:Message',
    Conversation: 'Famly.Conversation',
};

export class SearchResult extends Record<{
    id: string;
    title: string;
    subtitle: string;
    image: string;
    type: string;
    url: string;
    meta: any;
}>({
    id: '',
    title: '',
    subtitle: '',
    image: '',
    type: '',
    url: '',
    meta: null,
}) {}

export const fromAPI = (data: any) => {
    return new SearchResult({
        id: data.id,
        url: data.url,
        title: data.title,
        subtitle: data.subtitle,
        image: data.image,
        type: data.type,
        meta: data.meta,
    });
};
